// react and js
import { React, useMemo } from "react";
import { useTranslation } from "react-i18next";

// mui

// components
import Page from "../../components/Page";

// hooks

// layouts

// pages

// theme

// utils

// widgets
import WidgetLogin from "../../widgets/login/Login";

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export default function Login() {
  const { t } = useTranslation();

  // eslint-disable-next-line
  return useMemo(() => {
    return (
      <Page title={t("pages.login.title")}>
        <WidgetLogin />
      </Page>
    );
  }, [t]);
}
